<template>
  <ul
    :class="['handle-list-wrapper', displayLayout, isNewLayout, layoutVersion]"
  >
    <li
      :class="item.key"
      class="handle-item clickable flex-start"
      v-for="item in popupList"
      :key="item.key"
      @click="goToDetail(item)"
      v-show="item.show"
    >
      <div class="handle-item-line">
        <div v-if="hasNewMessage && item.key === 'message'">
          <van-badge
            :content="newMessageNum"
            max="99"
            :class="['handle-item-dot', messageNumLength]"
          >
            <MBIcon :size="iconSize" :name="item.icon" color="#ffffff" />
          </van-badge>
        </div>
        <MBIcon v-else :size="iconSize" :name="item.icon" color="#ffffff" />
      </div>
      <span class="handle-item-name">{{ item.title }}</span>
    </li>
  </ul>
</template>
<script>
  import MBIcon from '@/components/MBIcon'
  import { mapState, mapGetters } from 'vuex'
  import {
    accountDetailsClick,
    accountOrderClick,
    feedbackClick,
    shareShow,
    messageClick,
    couponClick,
    personal_whatsapp,
  } from '@/pages/firebase'
  import { trackWalletEntry } from '@/pages/Wallet/firebase'

  export default {
    components: {
      MBIcon,
    },
    props: {
      hasNewMessage: Boolean,
      newMessageNum: Number,
      currentPage: String,
    },
    computed: {
      ...mapState([
        'isTurbo',
        'isMobile',
        'isDesktop',
        'layoutVersion',
        'region',
        'userInfo',
        'allowUseMember',
      ]),
      ...mapGetters([
        'isNew',
        'displayLayout',
        'isNewLayout',
        'isRenderBindInfo',
      ]),
      iconSize() {
        if (this.isDesktop) return 20
        if (this.isMobile) return 60
        return 60
      },

      popupList() {
        const list = [
          /*{
            title: 'VIP',
            key: 'membersPrivilege',
            icon: 'icon-about',
            show: this.isDesktop,
          },*/
          {
            title: 'K-Wallet',
            key: 'myWallet',
            icon: 'icon-K-wallet',
            show: this.isDesktop && this.allowUseMember,
          },
          {
            title: this.$t('common.order'),
            key: 'order',
            icon: 'icon-order-thinner',
            show: true,
          },
          {
            title: this.$t('common.user_info'),
            key: 'account',
            icon: 'icon-user',
            show: !this.isTurbo,
          },
          {
            title: this.$t('message.message'),
            key: 'message',
            icon: 'icon-news',
            show: true,
          },
          {
            title: this.$t('common.customer_feedback'),
            key: 'contact',
            icon: 'icon-customer',
            show: !this.isTurbo,
            type: 'contact_us',
          },
          {
            title: this.$t('common.my_coupon'),
            key: 'coupon',
            icon: 'icon-coupon',
            show: true,
            type: 'coupon',
          },
          {
            title: this.$t('common.share'),
            key: 'share',
            icon: 'icon-share-o',
            show: true,
          },
          /*{
            title: this.$t('whatsapp.nav-title'),
            key: 'bind-mobile-phone',
            icon: 'icon-whatsapp',
            show: this.isRenderBindInfo,
          },*/
        ]
        if (this.region !== 'ru') return list
        return list.slice(1)
      },
      messageNumLength() {
        const map = {
          1: 'only-one',
          2: 'two-digits',
          3: 'longer',
        }
        let dLen = String(this.newMessageNum).length
        return map[dLen > 3 ? 3 : dLen]
      },
    },
    methods: {
      goToDetail(item) {
        let { key } = item || {}
        const gaTrackEventMaps = {
          myWallet: trackWalletEntry,
          account: accountDetailsClick,
          order: accountOrderClick,
          contact: feedbackClick,
          share: shareShow,
          message: messageClick,
          coupon: couponClick,
          'bind-mobile-phone': personal_whatsapp,
        }
        const { game } = this.$route.query
        const query = {
          ...this.$route.query,
          from: this.currentPage,
        }
        if (key === 'share') {
          gaTrackEventMaps[key]({ page: this.currentPage }, null, true)
          this.$emit('share')
          return
        }

        if (key === 'message') {
          gaTrackEventMaps[key]({
            page: this.currentPage,
            update: this.hasNewMessage ? 1 : 0,
          })
          this.$emit('message')
        } else if (key === 'myWallet') {
          delete query.orderNo
          query.from =
            this.currentPage === 'pay-result' ? game : this.currentPage
        } else if (key === 'bind-mobile-phone') {
          // 是否绑定成功
          if (this.userInfo?.phoneNumber) {
            key = 'bind-successful'
          }
        }
        gaTrackEventMaps[key] &&
          gaTrackEventMaps[key]({ page: this.currentPage })

        item.type && (query.type = item.type)
        this.$router_push({
          path: `/${key}`,
          query,
        })
      },
    },
  }
</script>
<style scoped lang="scss">
  .handle-list-wrapper {
    box-sizing: border-box;
    font-family: 'Roboto';
    .handle-item {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      height: 149px;
      border-bottom: 2px solid rgba(255, 255, 255, 0.05);

      .handle-item-icon {
        width: 60px;
      }

      .handle-item-name {
        margin-left: 40px;
        font-family: 'Roboto-Medium';
        font-weight: 500;
        font-size: 39px;
        line-height: 53px;
        color: #fff;
      }

      .handle-item-line {
        position: relative;
        display: flex;
        justify-content: center;
        align-content: center;
        // 消息红点
        .handle-item-dot {
          ::v-deep .van-badge {
            font-family: Roboto;
            font-weight: 600;
            font-size: 30px;
            line-height: 44px;
            height: 44px;
            background-color: #ff0000;
            color: #fff;
            border: none;
            padding: 0 13px;
            min-width: 44px;
          }
          ::v-deep .van-badge--fixed {
            position: absolute;
            top: 5px;
            right: 12px;
          }
          &.two-digits {
            ::v-deep .van-badge {
              padding: 0 14px 0 12px;
            }
            ::v-deep .van-badge--fixed {
              right: 2.5px;
            }
          }
          &.longer {
            ::v-deep .van-badge--fixed {
              right: -5px;
            }
          }
        }
      }
    }

    &.version-2-2 {
      .handle-item {
        border-bottom: 2px solid rgba(29, 29, 39, 0.05);
        .handle-item-name {
          color: #000000;
        }
      }
    }
  }
  // 适配 PC 端
  .handle-list-wrapper.desktop-layout {
    padding: 0;
    min-width: 220px;
    cursor: pointer;
    box-sizing: border-box;
    background: rgba(46, 46, 65, 0.98);
    .handle-item {
      height: 50px;
      padding: 0 20px;
      border-bottom: none;
      .handle-item-name {
        margin-left: 10px;
        font-weight: 500;
        font-size: 14px;
        line-height: 16px;
        color: #fff;
      }
      &:hover {
        background: #3d3d58;
      }
      &:active {
        .handle-item-name {
          color: #d9d9d9;
        }
        .handle-item-line {
          .iconfont {
            color: #d9d9d9 !important;
          }
        }
      }

      .handle-item-line .handle-item-dot {
        ::v-deep .van-badge {
          font-size: 12px;
          line-height: 15px;
          height: 14px;
          min-width: 14px;
          padding: 0 4.5px;
        }
        ::v-deep .van-badge--fixed {
          position: absolute;
          top: 2px;
          right: 0;
        }
        &.two-digits {
          ::v-deep .van-badge--fixed {
            right: 3px;
            padding: 0 3.3px;
          }
        }
        &.longer {
          ::v-deep .van-badge--fixed {
            top: -0.3px;
            right: 3px;
            padding: 0 2px;
          }
        }
      }
    }
  }
</style>
